import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import { t } from '../../services/i18nService';
import modalUtils from '../../qti/utils/ModalUtils';
import modalStyles from '../../styles/generic/modal.scss';
import storeManager from '../../store/StoreManager';
import responseActions from '../../actions/ResponseActions';
import footerService from '../../services/FooterService';
import oneWayConfirmationModalSelector from '../../selectors/modal/OneWayConfirmationModalSelector';
import uiActions from '../../actions/UIActions';
import responseService from '../../services/ResponseService';

const OneWayConfirmationModal = (props) => {
    const {
        confirmCaption,
        descriptionCaption,
        offerAutocommit,
        questionId,
        showModal,
        titleCaption,
    } = props;

    const [useAutocommit, setUseAutocommit] = useState(false);

    const handleToggleUseAutocommit = () => {
        setUseAutocommit(!useAutocommit);
    };

    const uncheckAutocommitting = () => {
        // uncheck when modal is closed by the cancel button
        setUseAutocommit(false);
    };

    const cancelCommitting = () => {
        storeManager.dispatch(responseActions.resetQuestionCommitTimestamp(questionId));
    };

    const confirmCommitting = () => {
        if (responseService.isOneWayNavigationDisallowedOfflineMode()) {
            storeManager.dispatch(responseActions.resetQuestionCommitTimestamp(questionId));
            storeManager.dispatch(responseActions.setOneWayNavigationOfflineCommitAttempt(true));
            return;
        }

        if (useAutocommit) {
            storeManager.dispatch(uiActions.setAnsweredQuestionAutocommit(true));
        }

        responseService.setQuestionCommitAnswerPendingStatus(questionId);
        footerService.gotoNextTestQuestion();
    };

    const selectParent = () => {
        return document.getElementById('app');
    };

    return (<Modal
        ariaHideApp={false}
        isOpen={showModal}
        onAfterClose={offerAutocommit ? uncheckAutocommitting : null}
        onRequestClose={cancelCommitting}
        parentSelector={selectParent}
        role="dialog"
        shouldCloseOnEsc
        shouldCloseOnOverlayClick={false}
        style={modalUtils.confirmationModalStyles}
        tabindex="0"
        aria={{ describedby: 'ownModalContent' }}
    >
        <div className={modalStyles.modalContentWrapper} id="ownModalContent">
            <h2 className={modalStyles.modalTitle}>
                { titleCaption }
            </h2>

            <div className={modalStyles.modalContent}>
                <div className={modalStyles.modalContentPart}>
                    { descriptionCaption }
                </div>

                { offerAutocommit &&
                    <div className={modalStyles.modalContentPart}>
                        <input type="checkbox" id="offerAutocommit" checked={useAutocommit} onChange={handleToggleUseAutocommit} />
                        <label htmlFor="offerAutocommit">
                            { t('navigation.oneWay.confirmationModal.offerAutocommit') }
                        </label>
                    </div>
                }
            </div>

            <div className={modalStyles.modalFooterButtons}>
                <button className={`btn default-btn ${modalStyles.modalSecondaryBtn}`} onClick={cancelCommitting}>
                    { t('general.cancel') }
                </button>

                <button className={`btn default-btn ${modalStyles.modalMainBtn}`} onClick={confirmCommitting}>
                    { confirmCaption }
                </button>
            </div>
        </div>
    </Modal>);
};

OneWayConfirmationModal.propTypes = {
    confirmCaption: PropTypes.string.isRequired,
    descriptionCaption: PropTypes.string.isRequired,
    offerAutocommit: PropTypes.bool.isRequired,
    questionId: PropTypes.number,
    showModal: PropTypes.bool.isRequired,
    titleCaption: PropTypes.string.isRequired,
};

const mapStateToProps = state => oneWayConfirmationModalSelector.selectProps(state);
export default connect(mapStateToProps)(OneWayConfirmationModal);
